import script from "./EditProjectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProjectModal.vue?vue&type=script&setup=true&lang=js"

import "./EditProjectModal.vue?vue&type=style&index=0&id=5e5a6ebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5a6ebc"]])

export default __exports__